const styles = (theme) => ({
  locationLabel: {
    color: theme.iconColor,
    fontSize: theme.textFontSize,
    fontWeight: 600,
    textTransform: 'uppercase',
    lineHeight: '16px',
    marginBottom: 10,
    marginTop: 14,
  },
});

export default styles;
